import request from '@/utils/request'

export function fetchPackageItemList (query) {
  return request({
    url: '/card/api/package_item/index',
    method: 'get',
    params: query
  })
}

export function fetchPackageItem (id) {
  return request({
    url: '/card/api/package_item/view',
    method: 'get',
    params: { id }
  })
}

export function createPackageItem (data) {
  return request({
    url: '/card/api/package_item/insert',
    method: 'post',
    data
  })
}

export function updatePackageItem (data) {
  return request({
    url: '/card/api/package_item/update',
    method: 'post',
    data
  })
}

export function deletePackageItem (id) {
  return request({
    url: '/card/api/package_item/delete',
    method: 'post',
    params: { id }
  })
}



// WEBPACK FOOTER //
// ./src/card/api/package-item.js